enum ChannelType {
  NONE = 0,
  P2P = 1,
  GROUP = 2
}

export default ChannelType;
